import { render, staticRenderFns } from "./weight.vue?vue&type=template&id=34b805da&"
import script from "./weight.vue?vue&type=script&lang=js&"
export * from "./weight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34b805da')) {
      api.createRecord('34b805da', component.options)
    } else {
      api.reload('34b805da', component.options)
    }
    module.hot.accept("./weight.vue?vue&type=template&id=34b805da&", function () {
      api.rerender('34b805da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/mbl/weight.vue"
export default component.exports